import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  Col,
  Nav,
  NavItem,
  NavLink,
  PopoverBody,
  Row,
  TabContent,
  TabPane,
  UncontrolledPopover,
} from "reactstrap"
import UpdateTable from "../../../components/Common/UpdatedTable"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { fetchStoreHistory } from "../../../services/centralStore/centralStore"
import TransferFilter from "./filter"
import { capitalize } from "lodash"
import NumberFormat from "../../../utils/numberFormat"
import { useLocation } from "react-router-dom"


const StockTransferHistory = () => {
  const companyname = localStorage.getItem('companyname')
  document.title = `Product List${companyname ? ` | ${companyname}` : 'MEP -Hub'}`;

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  const [activeTab, setActiveTab] = useState("1")
  const [search, setSearch] = useState("")
  const [fetchedData, setFetchedData] = useState()
  const [page, setPage] = useState("")
  const [projectNo, setProjectNo] = useState("")
  const [type, setType] = useState("")
  const [productNo, setProductNo] = useState("")
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  const handlePaginate = page => {
    setPage(page)
  }

  const handleProjectChange = id => {
    setProjectNo(id)
    setPage(1)
  }

  const handleTypeChange = id => {
    setType(id)
    setPage(1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleProductChange = data => {
    setProductNo(data)
    setPage(1)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchStoreHistory({
        params: `${activeTab && `&status=${activeTab == 1 ? 0 : activeTab == 2 ? 1 : 2}`
          }${`&sortOrder=asc`}${search ? `&searchText=${search}` : "&searchText"}${projectNo ? `&project_id=${projectNo}` : ""
          }${type ? `&type=${type}` : ""}${productNo ? `&product_id=${productNo}` : ""
          }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setFetchedData(response)
      const newData = response?.data?.data || [];

      setFetchedData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchData(activeTab)
  }, [activeTab, type, projectNo, search, productNo, dataPerPage])

  const columns = [
    // {
    //   label: "Requested From",
    //   renderCell: item => item?.request_id?.name,
    // },
    {
      label: "Project Number",
      renderCell: item =>
        item?.project_id != null
          ? item?.project_id?.project_code
          : "Company Products",
    },
    {
      label: "Product Number",
      renderCell: item => item?.product_id?.product_code,
    },
    {
      label: <div className="text-end pe-5">Quantity</div>,
      renderCell: item =>
        <>
          {item?.quantity ? (
            <div className="text-end pe-5">{
              `${item?.activity === "add" ? "+" : "-"} ${NumberFormat((Number(item?.quantity)))}`
            }</div>
          ) : (
            <div>-</div>
          )}
        </>,
    },
    {
      label: "Type",
      renderCell: item => (item?.type ? capitalize(item?.type) : "-"),
    },
  ]

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < fetchedData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [fetchedData, page]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Procurement"
              breadcrumbObject={[
                { title: "Procurement", link: "/procurement" },
                { title: crumb || "Stock Management", link: "/procurement" },
                {
                  title: "Stock Transfer Histories",
                  link: "/procurement/stock-transfer-history",
                },
              ]}
            />
          </div>

          <Card className="me-2 px-2 pb-2">
            <TransferFilter
              handleProjectChange={handleProjectChange}
              handleTypeChange={handleTypeChange}
              handleSearchChange={handleSearchChange}
              handleProductChange={handleProductChange}
            />
            <hr className="table-divide" />
            <div>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={activeTab === "1" ? "active pointer py-2" : "pointer py-2"}
                    onClick={() => {
                      toggle("1")
                    }}
                  >
                    New
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "2" ? "active pointer py-2" : "pointer py-2"}
                    onClick={() => {
                      toggle("2")
                    }}
                  >
                    Issued
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab === "3" ? "active pointer py-2" : "pointer py-2"}
                    onClick={() => {
                      toggle("3")
                    }}
                  >
                    Rejected
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab} className="pt-3">
                <TabPane tabId={activeTab}>
                  <Row className="ever-rise-table">
                    <Col xs={12}>
                      <div ref={tableContainerRef} style={{ maxHeight: "490px", overflowY: "auto" }}>
                        {fetchedData?.data?.data && (
                          <UpdateTable
                            //   className="mt-5"
                            nodes={fetchedData?.data?.data}
                            paginate={fetchedData?.data}
                            columns={columns}
                            CurrentPage={page}
                            handlePagination={handlePaginate}
                            handleSizePerPage={handleSizePerPageChange}
                            tableWidth="25% 25% 25% 25%"
                            mobileWidth="50% 50% 50% 50%"
                            isLoading={isLoadingNextPage}
                            hidePaginate={true}
                          />
                        )}
                      </div>
                    </Col>
                  </Row>
                </TabPane>
                {/* <TabPane tabId="2">

                </TabPane> */}
              </TabContent>
            </div>
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}></Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default StockTransferHistory
